export default [
    {
        icon: "fastfood",
        title: "ALIMENTOS Y BEBIDAS",
        description: "Una gama completa de bombas sanitarias para la industria de alimentos y bebidas. Contamos con bombas para alimentos y bebidas de diferentes viscosidades y temperaturas.",
    },
    {
        icon: "water",
        title: "TRATAMIENTO DE AGUAS",
        description: "Para el bombeo de agua limpia o tratada en aplicaciones de abastecimiento de agua y Para el transporte de agua muy contaminada que a menudo contiene partículas sólidas.",
    },
    {
        icon: "diamond",
        title: "MINERÍA",
        description: "Soluciones para la industria minera ya que la mayoría de las aplicaciones involucran productos abrasivos, desde el pozo hasta la presa.",
    },
    {
        icon: "local_pharmacy",
        title: "FARMACÉUTICA",
        description: "Junto con los cosméticos, la calidad y la tecnología se llevan al extremo debido a las estrictas regulaciones. Brindamos una calidad y precisión insuperables en línea con sus exigentes necesidades y estándares.",
    },
    {
        icon: "format_color_fill",
        title: "ENOLOGÍA",
        description: "Equipos especializados para la producción, traslado y manufactura. Soluciones para embotellado, trasvase de jugo, remontados, barricas y remontados de mosto.",
    },
    {
        icon: "science",
        title: "QUÍMICOS",
        description: "Una amplia gama de bombas  para soluciones químicas en la industria para diversas aplicaciones, tanto para la dosificación como para la transferencia de medios.",
    },
    {
        icon: "oil_barrel",
        title: "GAS",
        description: "Una gama completa de bombas especializadas para gas. Soluciones específicas para la viscosidad y tratamiento.",
    },
    {
        icon: "local_shipping",
        title: "AUTOMOTRIZ",
        description: "Soluciones muy específicas como movimiento de solventes, líquidos, combustible, aditivos o construcción específica en el área automotriz.",
    },
    {
        icon: "takeout_dining",
        title: "CERÁMICOS",
        description: "Soluciones para la industria cerámica, en áreas para la dosificación de aditivos, movimiento de fluidos, solventes o para el trasvase de medios."
    },
]